import { jsx as _jsx } from "react/jsx-runtime";
import { GDPR_PREFERENCES_COOKIE } from '@wkda/gdprlib';
import { useEffect, useState } from 'react';
import { GDPRBanner, GDPRBannerForm } from './GDPRBanner';
import { GDPRBannerStateProvider } from './useGDPRBanner';
function GDPRContainer({ cookieService, isProd, APIService, content, closeHandler, onSubmit, className, ignorePreferencesCookie = false, }) {
    const [canRender, setCanRender] = useState(false);
    useEffect(() => {
        if (content &&
            (ignorePreferencesCookie || !cookieService.get(GDPR_PREFERENCES_COOKIE))) {
            setCanRender(true);
        }
        else if (typeof closeHandler === 'function') {
            closeHandler();
        }
    }, []);
    return canRender ? (_jsx(GDPRBannerStateProvider, { cookieService: cookieService, isProd: isProd, APIService: APIService, onSubmit: onSubmit, children: _jsx(GDPRBanner, { content: content, onClose: closeHandler, className: className }) })) : null;
}
export { GDPRContainer as GDPRBanner, GDPRBannerForm, GDPRBannerStateProvider };
